import React from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";

const TabPanel = ({ children, value, index, ...rest }) => {
	return (
		<Box
			role="tabpanel"
			hidden={value !== index}
			id={`full-width-tabpanel-${index}`}
			// ariaLabelledby={`full-width-tab-${index}`}
			{...rest}
		>
			{value === index && (
				<Box sx={{ p: 2 }}>
					{children}
				</Box>
			)}
		</Box>
	)
}

TabPanel.propTypes = {
	children: PropTypes.node.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

TabPanel.defaultProps = {
	value: "0",
	index: "0",
};

export default TabPanel;
